import {get} from '../utils'
import {getActiveChannel, isPublicChannel} from "../authentication/utils";

export default host => (livestreamId) =>
  get(`${host}${isPublicChannel() ? "/public": ""}/channels/${getActiveChannel()}/livestreams/${livestreamId}/canView`)
    .then(response => response.json())